import Role from '@/models/enums/Roles'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

function isSuperAdmin (userRoles) {
  if (!Array.isArray(userRoles)) {
    return false
  }

  return userRoles.includes(Role.SuperAdmin)
}

export default {
  computed: {
    isSuperAdmin () {
      return isSuperAdmin(this.$store.getters['auth/getRoles'])
    },
    // Супер-админ работает в чужих сетях, своего платёжного аккаунта у него нет,
    // а userCan для него всегда true — поэтому биллинг отсекаем отдельно
    canUseBilling () {
      return !this.isSuperAdmin && this.userCan(CRMPermission.ManagePaymentAccount)
    },
    // Смотреть биллинг может и супер-админ (заходит в чужую сеть), и тот,
    // кому выдали только просмотр. Действия остаются на canUseBilling.
    canViewBilling () {
      return this.isSuperAdmin ||
        this.canUseBilling ||
        this.userCan(CRMPermission.ViewPaymentAccount)
    },
    // Долг клиента не останавливает супер-админа и собственника сети, зашедших в неё
    billingBlocked () {
      return !this.userIs([Role.SuperAdmin, Role.Owner]) &&
        !!this.$store.state.billing.paymentAccount.blocked
    },
    userCan () {
      return function (value) {
        const roles = this.$store.getters['auth/getRoles']
        const permissions = this.$store.getters['auth/getPermissions']

        if (isSuperAdmin(roles)) {
           return true
        }

        if (!Array.isArray(permissions)) {
          return false
        }

        if (Array.isArray(value)) {
          value = value.join('|')
        }

        let _return = false

        if (value.includes('|')) {
          value.split('|').forEach(function (item) {
            if (permissions.includes(item.trim())) {
              _return = true
            }
          })
        } else if (value.includes('&')) {
          _return = true
          value.split('&').forEach(function (item) {
            if (!permissions.includes(item.trim())) {
              _return = false
            }
          })
        } else {
          _return = permissions.includes(value.trim())
        }
        return _return
      }
    },
    userIs () {
      return function (value) {
        const roles = this.$store.getters['auth/getRoles']

        if (isSuperAdmin(roles)) {
          return true
        }

        if (!Array.isArray(roles)) {
          return false
        }

        if (Array.isArray(value)) {
          value = value.join('|')
        }

        let _return = false

        if (value.includes('|')) {
          value.split('|').forEach(function (item) {
            if (roles.includes(item.trim())) {
              _return = true
            }
          })
        } else if (value.includes('&')) {
          _return = true
          value.split('&').forEach(function (item) {
            if (!roles.includes(item.trim())) {
              _return = false
            }
          })
        } else {
          _return = roles.includes(value.trim())
        }

        return _return
      }
    },
  },

}
